import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="default-footer bg_cover" style={{ backgroundImage: 'url(/assets/images/home-one/footer/footer-bg.jpg)' }}>
      <div className="container">
        <div className="footer-widget-area pt-100 pb-50">
          <div className="row">
            <div className="col-xl-3 col-md-6 col-sm-12">
              <div className="footer-widget footer-about-widget mb-40">
                <div className="widget-content">
                  <img src="/images/fsl_logo.png" alt="FSL HMO Logo" style={{ height: '50px' }} className="mb-25" />
                  <p>FSL HMO offers Healthcare Solutions, medicines, diagnostics, and wellness products for better health.</p>
                  <div className="social-box">
                    <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">
                      <i className="fab fa-facebook-f"></i>
                    </a>
                    <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
                      <i className="fab fa-twitter"></i>
                    </a>
                    <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer">
                      <i className="fab fa-linkedin-in"></i>
                    </a>
                    <a href="https://pinterest.com" target="_blank" rel="noopener noreferrer">
                      <i className="fab fa-pinterest-p"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-5">
              <div className="row ps-xl-5">
                <div className="col-md-6">
                  <div className="footer-widget footer-nav-widget mb-40">
                    <h4 className="widget-title">Quick Links</h4>
                    <div className="widget-content">
                      <ul className="widget-nav">
                        <li><Link to="/">Home</Link></li>
                        <li><Link to="/about">About Us</Link></li>
                        <li><Link to="/plans">Plans</Link></li>
                        <li><Link to="/contact">Contact Us</Link></li>
                      </ul>
                    </div>
                  </div>
                </div>
               
              </div>
            </div>
            <div className="col-xl-4 col-md-6">
              <div className="footer-widget footer-contact-info-widget mb-40">
                <h4 className="widget-title">Contact Us</h4>
                <div className="widget-content">
                  <div className="medolia-info-box mb-25">
                    <div className="icon"><i className="fas fa-phone"></i></div>
                    <div className="content"><p>+234 (815) 159-0112</p></div>
                  </div>
                  <div className="medolia-info-box mb-25">
                    <div className="icon"><i className="far fa-envelope"></i></div>
                    <div className="content"><p>info@fsl.ng</p></div>
                  </div>
                  <div className="medolia-info-box mb-25">
                    <div className="icon"><i className="fas fa-map-marker-alt"></i></div>
                    <div className="content">
                      <p>Plot 688 Ahmodu Tijani Close,<br />
                      Off Sanusi Fafunwa Street,<br />
                      Victoria Island, Lagos State, Nigeria</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="copyright-area">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="copyright-text text-center">
                  <p>&copy; {currentYear} All rights reserved by FSL HMO</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;